import React from "react";
import "./video-montage.css";
import VisibilitySensor from "react-visibility-sensor";
const VideoMontageMobile = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  const onVisibilityChange = (isVisible) => {
    if (isVisible) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor
      onChange={onVisibilityChange}
      offset={{
        top: 100,
      }}
      delayedCall
      partialVisibility
    >
      <section className="z-50 relative" id="integration">
        <div className="h-screen relative z-30 flex  justify-center items-center bg-black overflow-hidden ">
          <video
            id="videoMachine"
            width="100%"
            autoPlay
            loop
            muted
            playsInline
            className="absolute z-0  scale-[3.6] md:scale-[2] lg:scale-100"
          >
            <source
              src="https://cdn.pmlsound.com/anthem/Avm90_Montage.mp4"
              type="video/mp4"
            />
          </video>

          <div className="relative w-full max-w-3xl mx-auto text-white text-center ">
            <div className="absolute   inset-x-0 bottom-0 w-full ">
              <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center  text-white leading-snug drop-shadow-lg ">
                <span className={isVisible ? "elevate-span" : null}>
                  Elevate.
                </span>
                <span className={isVisible ? "refine-span" : null}>
                  {" "}
                  Refine.
                </span>
                <span className={isVisible ? "enhance-span" : null}>
                  {" "}
                  Enhance.
                </span>
              </h4>
            </div>
          </div>
        </div>
      </section>
    </VisibilitySensor>
  );
};

export default VideoMontageMobile;
